import { Fragment, PropsWithChildren, useCallback, useState } from "react";
import { css } from "@emotion/react";
import { Pagination } from "../Pagination/Pagination";

export interface WithPaginationProps {
  /**
   * ページネーションが生える
   */
  onPaginate?: (index: number) => void;
  /**
   * ページネーションの数、ページネーションはとりあえず上下に生やす、将来的にはstikcyでもいいかも
   */
  pageTotal?: number;
}

const WithPaginationInner = ({
  pageTotal,
  onPaginate,
  children,
}: PropsWithChildren<Required<WithPaginationProps>>) => {
  const [pageIndex, setPageIndex] = useState(0);
  const handleChangePage = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, index: number) => {
      setPageIndex(index);
      onPaginate(index);
    },
    [onPaginate],
  );
  return (
    <div>
      <div
        css={css`
          display: flex;
          justify-content: flex-end;
          margin-bottom: 8px;
        `}
      >
        <Pagination
          pageIndex={pageIndex}
          onChangePage={handleChangePage}
          pageSize={pageTotal}
        />
      </div>
      {children}
      <div
        css={css`
          display: flex;
          justify-content: center;
          padding: 8px;
          border: 2px solid #e0e0e0;
          border-top: none;
        `}
      >
        <Pagination
          pageIndex={pageIndex}
          onChangePage={handleChangePage}
          pageSize={pageTotal}
        />
      </div>
    </div>
  );
};

export const WithPagination = ({
  pageTotal,
  onPaginate,
  children,
}: PropsWithChildren<WithPaginationProps>) => {
  if (onPaginate !== undefined && pageTotal !== undefined) {
    return (
      <WithPaginationInner pageTotal={pageTotal} onPaginate={onPaginate}>
        {children}
      </WithPaginationInner>
    );
  } else {
    return <Fragment>{children}</Fragment>;
  }
};
